<template>
  <section
    class="n-section-primary tw-grid tw-grid-cols-12 tw-items-start tw-gap-6 !tw-pt-32 md:tw-mt-28 lg:!tw-pt-20"
    :style="vars.backgroundColor ? `background-color: var(--c-${vars.backgroundColor})` : ''"
  >
    <h2 class="tw-col-span-12 tw-w-full">{{ vars.titleText }}</h2>
    <div class="tw-col-span-12">
      <div>
        <div v-if="properties.length">
          <lazy-library-properties-page-list
            :theme="theme"
            :component="component"
            :properties="properties"
            :columns="vars.columnsNumber"
            :pre-market-property-feature="vars.preMarketPropertyFeatureBool"
            :version="vars.propertyListItemVersionText"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertiesMixin } from '~/units/properties/mixins/properties.mixin';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'Theme4BranchProperties',

  mixins: [ComponentMixin, PropertiesMixin],

  components: {},

  async setup(props) {
    await fetchPropertiesManager(props.component, null);
  },
});
</script>
